export const rowGutter = 4;
export const colon = false;
